const features = [
  {
    icon: 'ri-book-open-line',
    title: '海量资源',
    desc: '收录超过30,000部漫画作品，涵盖韩漫、日漫、国漫、条漫等多元类型，满足各类读者的阅读偏好。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-smartphone-line',
    title: '流畅阅读',
    desc: '专为移动端优化的下拉式阅读体验，自动适配屏幕尺寸，加载迅速，翻页丝滑无卡顿。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-arrow-down-circle-line',
    title: '完全免费',
    desc: '无需注册、无需付费，所有漫画资源永久免费开放，让每位读者都能无门槛享受阅读乐趣。',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '热门连载每日同步更新，第一时间追更最新话，精彩剧情不再等待，阅读节奏由你掌控。',
    color: 'bg-primary-100 text-primary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-star-line"></i>
            优势
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">平台特色</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            为什么千万读者选择香蕉动漫？四大核心优势告诉你答案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 md:p-7 text-center hover:bg-background-200/70 transition-colors cursor-default"
            >
              <div className={`w-14 h-14 mx-auto flex items-center justify-center rounded-xl ${feat.color} mb-4`}>
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-3">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}